import axios from "axios";
import { StatusCodes } from "http-status-codes";
import { ENV, getCDNOrigin } from "../utils/envReader.util";
import { getStatusCode } from "../utils/service.util";
import { Expertise } from "../types/expertises.type";

const link = "https://www.hwr-berlin.de/hwr-berlin/ueber-uns/person/detail/797-heike-wiesner";

/**
 * Get all expertises
 * @returns expertise type as array
 */
export async function getExpertises(): Promise<
    Expertise[] | undefined
> {
    try {
        const request = await axios.get(`${getCDNOrigin()}/api/expertises?populate=*`, {
            headers: {
                Authorization: `Bearer ${ENV.CDN_TOKEN}`,
            }
        });

        const statusCode = getStatusCode(request);
        if (statusCode === StatusCodes.OK) {
            return request.data.data as Expertise[];
        } else {
            console.error(`COULD NOT GET DATA FROM CDN REQUEST! REQUEST: ${request}`);
            window.location.href = link;
        }
    } catch(error: unknown) {
        console.error(`COULD NOT GET DATA FROM CDN REQUEST! ERROR: ${error}`);
        window.location.href = link;
    };
};

/**
 * Get all Foerderers logo
 * @returns logo images
 */
export async function getFoerderers(): Promise<
    any
> {
    try {
        const request = await axios.get(`${getCDNOrigin()}/api/foerderers?populate=*`, {
            headers: {
                Authorization: `Bearer ${ENV.CDN_TOKEN}`,
            }
        });

        const statusCode = getStatusCode(request);
        if (statusCode === StatusCodes.OK) {
            return request.data.data;
        } else {
            console.error(`COULD NOT GET DATA FROM CDN REQUEST! REQUEST: ${request}`);
            window.location.href = link;
        }
    } catch(error: unknown) {
        console.error(`COULD NOT GET DATA FROM CDN REQUEST! ERROR: ${error}`);
        window.location.href = link;
    };
};

/**
 * Get all lebenslauf data
 * @returns lebenslauf data
 */
export async function getLebenslaeufe(): Promise<
    any
> {
    try {
        const request = await axios.get(`${getCDNOrigin()}/api/lebenslaeufe`, {
            headers: {
                Authorization: `Bearer ${ENV.CDN_TOKEN}`,
            }
        });

        const statusCode = getStatusCode(request);
        if (statusCode === StatusCodes.OK) {
            return request.data.data;
        } else {
            console.error(`COULD NOT GET DATA FROM CDN REQUEST! REQUEST: ${request}`);
            window.location.href = link;
        }
    } catch(error: unknown) {
        console.error(`COULD NOT GET DATA FROM CDN REQUEST! ERROR: ${error}`);
        window.location.href = link;
    };
};

/**
 * Get all publikationen data
 * @returns publikationen data
 */
export async function getPublikationen(): Promise<
    any
> {
    try {
        const request = await axios.get(`${getCDNOrigin()}/api/publikationen`, {
            headers: {
                Authorization: `Bearer ${ENV.CDN_TOKEN}`,
            }
        });

        const statusCode = getStatusCode(request);
        if (statusCode === StatusCodes.OK) {
            return request.data.data;
        } else {
            console.error(`COULD NOT GET DATA FROM CDN REQUEST! REQUEST: ${request}`);
            window.location.href = link;
        }
    } catch(error: unknown) {
        console.error(`COULD NOT GET DATA FROM CDN REQUEST! ERROR: ${error}`);
        window.location.href = link;
    };
};

/**
 * Get all Projekte
 * @returns Projekte data
 */
export async function getProjekte(): Promise<
    any
> {
    try {
        const request = await axios.get(`${getCDNOrigin()}/api/projekte?populate=*`, {
            headers: {
                Authorization: `Bearer ${ENV.CDN_TOKEN}`,
            }
        });

        const statusCode = getStatusCode(request);
        if (statusCode === StatusCodes.OK) {
            return request.data.data;
        } else {
            console.error(`COULD NOT GET DATA FROM CDN REQUEST! REQUEST: ${request}`);
            window.location.href = link;
        }
    } catch(error: unknown) {
        console.error(`COULD NOT GET DATA FROM CDN REQUEST! ERROR: ${error}`);
        window.location.href = link;
    };
};

/**
 * Get all Lehrveranstraltungen
 * @returns Lehrveranstaltungen data
 */
export async function getLehrveranstaltungen(): Promise<
    any
> {
    try {
        const request = await axios.get(`${getCDNOrigin()}/api/lehrveranstaltungen`, {
            headers: {
                Authorization: `Bearer ${ENV.CDN_TOKEN}`,
            }
        });

        const statusCode = getStatusCode(request);
        if (statusCode === StatusCodes.OK) {
            return request.data.data;
        } else {
            console.error(`COULD NOT GET DATA FROM CDN REQUEST! REQUEST: ${request}`);
            window.location.href = link;
        }
    } catch(error: unknown) {
        console.error(`COULD NOT GET DATA FROM CDN REQUEST! ERROR: ${error}`);
        window.location.href = link;
    };
};

/**
 * Get all Workshops
 * @returns Workshop data
 */
export async function getWorkshops(): Promise<
    any
> {
    try {
        const request = await axios.get(`${getCDNOrigin()}/api/workshops`, {
            headers: {
                Authorization: `Bearer ${ENV.CDN_TOKEN}`,
            }
        });

        const statusCode = getStatusCode(request);
        if (statusCode === StatusCodes.OK) {
            return request.data.data;
        } else {
            console.error(`COULD NOT GET DATA FROM CDN REQUEST! REQUEST: ${request}`);
            window.location.href = link;
        }
    } catch(error: unknown) {
        console.error(`COULD NOT GET DATA FROM CDN REQUEST! ERROR: ${error}`);
        window.location.href = link;
    };
};